const goToAnchor = () => { 
    var lnks = document.querySelectorAll('a[href*="#"]');
    let headerOffset = 0;
    if(window.innerWidth > 1200){
        headerOffset = document.querySelector(".site-header__middle-bar").offsetHeight;
    }else{
        headerOffset = document.querySelector(".site-header").offsetHeight;
    }
    // Aggiungo un offset extra per assicurarmi che il contenuto non venga nascosto
    headerOffset += 100;
    
    lnks.forEach(el => {
        el.addEventListener('click', function(e) {
            e.preventDefault();
            if(document.querySelector('#accordionIndice')){
                headerOffset = headerOffset + document.querySelector('#accordionIndice').offsetHeight + 60;
            }
            let targetVal = el.getAttribute('href');
            
            // Se il link contiene un percorso completo
            if(targetVal.indexOf('/') > -1) {
                // Se contiene anche un'ancora
                if(targetVal.indexOf('#') > -1) {
                    const [path, hash] = targetVal.split('#');
                    window.location.href = path;
                    // Aspetta che la pagina si carichi prima di scrollare
                    setTimeout(() => {
                        const target = document.querySelector('#' + hash);
                        if(target) {
                            const rect = target.getBoundingClientRect();
                            const offsetPosition = rect.top + window.scrollY - headerOffset;
                            window.scrollTo({
                                top: offsetPosition,
                                behavior: "smooth"
                            });
                        }
                    }, 100);
                } else {
                    window.location.href = targetVal;
                }
            } else {
                let target = document.querySelector(targetVal);
                const rect = target.getBoundingClientRect();
                const offsetPosition = rect.top + window.scrollY - headerOffset;
                window.scrollTo({
                    top: offsetPosition,
                    behavior: "smooth"
                });
            }
        });
    });
};
export default goToAnchor;